import LayoutActividad from "../../../components/LayoutActividad";
import Sentencia from "../../../images/modulo14/sentencia.png";

import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad9 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[11];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[0].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[0].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[10].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-9 col-12 p-md-3 p-0">
            <h4 className="mb-5">
              <strong>Muchas lenguas, mucha riqueza</strong>
            </h4>
            <p className="mt-1">
              Una de las principales riquezas de nuestro país está en la{" "}
              <strong>diversidad de lenguas</strong> que hablamos los peruanos.
            </p>
            <p>
              Sin embargo, durante muchos años, se consideró al castellano como
              la única lengua importante del Perú. La educación en las escuelas
              era <strong>solo en castellano</strong>, los juzgados solo
              atendían a las personas en castellano.
            </p>
            <p>
              Actualmente, se reconoce a la{" "}
              <strong>educación intercultural bilingüe</strong> (educación en
              castellano y en la lengua originaria de la comunidad) como un
              derecho. El año 2015, además, se dio la primera{" "}
              <strong>sentencia judicial</strong> en lengua aimara, en Puno.
              Estas son buenas noticias para todas las personas de nuestro país.
            </p>
          </div>
          <div className="col-md-3 col-12">
            <img
              src={Sentencia}
              className="bg-white img-fluid rounded w-100"
              alt="Sentencia"
            />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea en voz alta el texto titulado Muchas lenguas, mucha riqueza.
          </li>
          <li>
            Luego, pida que lean el
            texto por segunda vez. Cierre la actividad resaltando las ideas
            clave del texto leída:
            <ul>
              <li>
                <i>
                  “A pesar de la diversidad de lenguas originarias con la que
                  siempre ha contado el Perú y la riqueza que ello significa, el
                  castellano fue más valorado. Esta situación no solamente hizo
                  que, como hemos visto, se extinguieran algunas lenguas, sino
                  que ocasionó también que se limitara el acceso a ciertos
                  servicios de las personas que solo hablaban lenguas
                  originarias. Mucho tiempo transcurrió para que la educación
                  bilingüe sea un derecho. Asimismo, en el sistema judicial algo
                  se ha avanzado para que los servicios ofrecidos sean
                  bilingües. El reconocimiento de la diversidad lingüística como
                  una riqueza del país resulta fundamental para la convivencia
                  ya que nos lleva a aceptar la condición de igualdad y respeto,
                  independientemente de las diferencias de lenguas, de todos los
                  peruanos y peruanas”
                </i>
              </li>
            </ul>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
